export function APIEndpoint() {
    const endpoind = 'http://localhost:5001/v1';
    // const endpoind = 'https://minto-codeconcept.tk';
    //const endpoind = 'https://api-barbaraminto.i2mdev.com';
    return endpoind;
};

export function GlobalRedirects() {
    const rules = {
        AFTER_LOGIN: 'site.dashboard',
        AFTER_LOGOUT: 'auth.login',
        LOGIN: 'auth.login'
    };
    return rules;
};



// WEBPACK FOOTER //
// ./client/app/core/core.config.js